import React from 'react';
import {BrowserRouter as Router, Route} from "react-router-dom";
import LoginPage from "./LoginPage";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import UserRestrictedRoute from "../components/misc/UserRestrictedRoute";
import * as firebase from "firebase/app";
import EventsPage from "./EventsPage";
import config from "../config/config";
import BILogo from '../images/BILogo.png';

firebase.initializeApp(config.firebaseConfig);

class App extends React.Component {

    render() {
        return (
            <>
                <Router>
                    <ToastContainer/>
                    <Route path="/" exact component={LoginPage}/>
                    <UserRestrictedRoute path="/events" exact component={EventsPage}/>
                </Router>
            </>
        );
    }
}

export default App;